import React from "react";
import { classNames } from "components/utils";
import { Button } from "components/Graphs/Button";
import { Tooltip } from "@mui/material";

interface CloudDisplayProps {
  provider?: string;
  cloud?: string;
  region?: string;
  className?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  tooltip?: string;
}

const CloudDisplay: React.FC<CloudDisplayProps> = ({
  provider = "Unknown Provider",
  cloud,
  className,
  icon,
  onClick,
  tooltip,
}) => {
  const isClickable = !!onClick;

  const baseClasses = classNames(
    "flex items-center",
    "text-sm",
    "",
    isClickable
      ? "cursor-pointer rounded-md transition-colors hover:text-highlight"
      : "",
    className || ""
  );

  const content = (
    <>
      <div className={classNames("flex flex-col")}>
        {/* {provider !== "AWS" && provider !== "GCP" && ( */}
        {/* )} */}
        <div className="flex flex-row items-center gap-1">
          {icon && <span className="flex-shrink-0">{icon}</span>}
          <p className="text-sm leading-[10px]">
            {provider}
            {cloud ? <span className="text-[8px] ml-1">({cloud})</span> : ""}
          </p>
        </div>
      </div>
    </>
  );

  if (isClickable) {
    return (
      <Tooltip
        title={tooltip}
        placement="top"
        PopperProps={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5], // Move tooltip down by 16px (adjust as needed)
              },
            },
          ],
        }}
      >
        <Button
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onClick?.();
          }}
          className={baseClasses}
          type="button"
          variant="noshow"
        >
          {content}
        </Button>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip} placement="top">
      <div className={baseClasses}>{content}</div>
    </Tooltip>
  );
};

export default CloudDisplay;
